/**
 * 初回利用申請画面
*/
import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import dialogService from "../../services/common/dialogService";
import jyuService from "../../services/jyu/jyuService";
import IsdTextBox from "../common/isdTextBox";
import "../../css/jyu/Jyuf102.css"
import asyncService from "../../services/common/asyncService";
import { observer } from "mobx-react";
import stateStore from "../../store/stateStore";
import rootScope from "../../store/rootScopeStore";
import errMsgService from "../../services/common/errMsgService";
import pocs from "../../services/pocs";
import IsdTextboxSuggest from "../common/isdTextboxSuggest";
import { goto } from "../../util/isd-utils";
import { getMsg } from "../../util/util";

// 動作監視用
const Jyuf102 = observer(() => {
    const dispatch = useDispatch();
    const ref = {
        email: useRef(null),
        telephone: useRef(null),
        mobile: useRef(null),
    }

    useEffect(() => {
        stateStore.state = {
            tksakicd: '',
            tksakimei: '',
            tntomei: '',
            email: '',
            telephone: '',
            mobile: '',
            suggestData: []
        };
    }, []);

    // 電話番号または携帯電話番号が入力されていることを確認します
    const checkPhoneNumber = event => {
        const { name, value } = event.target;
        errMsgService.delMsgKey('telephone');
        errMsgService.delMsgKey('mobile');
        if (!stateStore.state.telephone && !stateStore.state.mobile) {
            errMsgService.addMsgKey('EJYU0150', name);
        }
    }

    // ログイン画面に戻る。
    const okFunc = () => {
        goto('Login');
    }

    // 初回申請情報更新IFを呼び出してデータを登録する。
    const requestOnClick = () => {
        let dataRegist = {};
        dataRegist.tksakicd = stateStore.state.tksakicd;
        dataRegist.tksakimei = stateStore.state.tksakimei;
        dataRegist.tntomei = stateStore.state.tntomei;
        dataRegist.email = stateStore.state.email;
        dataRegist.telephone = stateStore.state.telephone;
        dataRegist.mobile = stateStore.state.mobile;
        if (!stateStore.state.telephone && !stateStore.state.mobile) {
            ref.telephone.current.element.focus();
        }
        else{
            dispatch(asyncService.async(jyuService.jyua107(dataRegist), (response) => {
                if (response) {
                    dialogService.okDialog(response.messageCode, getMsg(response.messageCode), null, okFunc);
                }
            }));
            // 申請ボタンからフォーカスを外す
            document.activeElement.blur();
        }
    };
    
        

    return (
        <div>
            <div>
                <label htmlFor="tksakimei">得意先名称</label>
                <div className="jyuf02-input-display ml31">
                    <IsdTextBox required ctrlproptype="japan"
                        id="tksakimei" name="tksakimei" value={stateStore.state?.tksakimei} isdmaxlength="80">
                    </IsdTextBox>
                </div>
            </div>
            <div className="mt5">
                <label htmlFor="tntomei">担当者名称 姓</label>
                <div className="jyuf02-input-display ml12">
                    <IsdTextBox required id="tntomei" ctrlproptype="japan" isdmaxlength="16" name="tntomei" value={stateStore.state?.tntomei}
                    />
                </div>
            </div>

            <div className="mt5">
                <label htmlFor="email">メールアドレス</label>
                <div className="jyuf02-input-display ml3">
                    <IsdTextBox required id="email" name="email" ctrlproptype="japan" checkFormat="mail" isdmaxlength="60" value={stateStore.state?.email}
                        ref={ref.email} />
                </div>
            </div>
            <div className="mt5">
                <label htmlFor="telephone">電話番号</label>
                <div className="jyuf02-input-display ml45">
                    <IsdTextBox name="telephone" id="telephone" ctrlproptype="tel" isdmaxlength="13" placeholder="数字のみ入力してください" value={stateStore.state?.telephone}
                        ref={ref.telephone} onBlur={checkPhoneNumber} />
                </div>
            </div>
            <div className="mt5">
                <label htmlFor="mobile">携帯番号</label>
                <div className="jyuf02-input-display ml45">
                    <IsdTextBox name="mobile" id="mobile" ctrlproptype="tel" isdmaxlength="13" placeholder="数字のみ入力してください" value={stateStore.state?.mobile}
                        ref={ref.mobile} onBlur={checkPhoneNumber} />
                </div>
            </div>
            <div className="mt15 ml75">
                <button className="btn ng-binding btn-custom" onClick={requestOnClick} disabled={rootScope.requireDisabledFlg}>申請</button>
            </div>
            <div className="mt15"><a>※申請後、数日経ってもメールが届かない場合はご連絡下さい。</a></div>
        </div>
    )
})
export default Jyuf102;